// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1oAnn","title":"Header_title__21w6Y","left":"Header_left__1FZfJ","clinicName":"Header_clinicName__1jzS8"};